"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.failedEnrollUser = exports.failedAuthenticateUser = exports.getFaceTecDatabaseReference = exports.successfullyAuthenticateUser = exports.captureFaceTecDatabaseReference = exports.successfullyEnrollUser = void 0;
const store_1 = require("../store");
const ui_1 = require("../reducers/slices/ui");
/**
 * Helper functions for FaceTec authentication.
 * These functions are called by FaceTec processors to dispatch Redux actions.
 *
 * Pattern: Global store import (matches sky_lifestyle_crm_web)
 */
// Enrollment helpers
function successfullyEnrollUser() {
    store_1.redux_store.dispatch((0, ui_1.enrollmentCompleted)());
}
exports.successfullyEnrollUser = successfullyEnrollUser;
function captureFaceTecDatabaseReference(userId) {
    if (userId) {
        store_1.redux_store.dispatch((0, ui_1.setFacetecDatabaseReference)(userId));
    }
}
exports.captureFaceTecDatabaseReference = captureFaceTecDatabaseReference;
// Authentication helpers
function successfullyAuthenticateUser() {
    store_1.redux_store.dispatch((0, ui_1.faceTecAuthenticated)());
}
exports.successfullyAuthenticateUser = successfullyAuthenticateUser;
// Getters
function getFaceTecDatabaseReference() {
    return store_1.redux_store.getState().uiState.facetecDatabaseReference;
}
exports.getFaceTecDatabaseReference = getFaceTecDatabaseReference;
// Failure handlers
function failedAuthenticateUser(errorMessage) {
    store_1.redux_store.dispatch((0, ui_1.faceTecAuthenticationFailed)(errorMessage));
}
exports.failedAuthenticateUser = failedAuthenticateUser;
function failedEnrollUser(errorMessage) {
    store_1.redux_store.dispatch((0, ui_1.faceTecEnrollmentFailed)(errorMessage));
}
exports.failedEnrollUser = failedEnrollUser;
